import { Divider, List, Typography } from '@mui/material';
import { ReportItem, ResearchReport, SortMode } from '../types';
import { ReportGroup } from './ReportGroup';
import { SingleReport } from './SingleReport';
import { ReportsContainer } from '../styles';
import { ReportsListHeader } from './ReportsListHeader';
interface ReportsListProps {
  currentSelected: ReportItem | undefined;
  isVisible: boolean;
  onReportClick: (report: ReportItem) => void;
  onToggleReportsList: () => void;
  onParentReportClick: (report: string) => void;
  open: Record<string, boolean>;
  sortedReports: ResearchReport[] | undefined;
  updateSortMode: (sortMode: SortMode) => void;
  sortMode: SortMode;
}

export const ReportsList = ({
  currentSelected,
  isVisible,
  onReportClick,
  onToggleReportsList,
  onParentReportClick,
  open,
  sortedReports,
  updateSortMode,
  sortMode,
}: ReportsListProps) => {
  return (
    <ReportsContainer isVisible={isVisible} sx={{ borderRight: '1px solid rgba(255, 255, 255, 0.12)' }}>
      <ReportsListHeader isVisible={isVisible} onToggleReportsList={onToggleReportsList} onChangeSortMode={updateSortMode} sortMode={sortMode} />
      <Divider />
      {isVisible && (
        <List sx={{ overflow: 'auto', maxHeight: '100%' }}>
          {sortedReports && sortedReports.length > 0 ? (
            sortedReports.map(report =>
              report.report.length > 1 ? (
                <ReportGroup
                  key={report.category}
                  category={report.category}
                  reports={report.report}
                  isOpen={open[report.category]}
                  onParentClick={() => onParentReportClick(report.category)}
                  onReportClick={onReportClick}
                  currentSelected={currentSelected}
                />
              ) : (
                <SingleReport
                  key={report.category}
                  category={report.category}
                  report={report.report[0]}
                  onReportClick={onReportClick}
                  isSelected={
                    currentSelected?.report_name === report.report[0].report_name &&
                    currentSelected?.report_link === report.report[0].report_link &&
                    currentSelected?.category === report.category
                  }
                />
              )
            )
          ) : (
            <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary', padding: 2 }}>
              No reports to display
            </Typography>
          )}
        </List>
      )}
    </ReportsContainer>
  );
};
